<template>
  <div id="lom-list">
    <v-dialog v-model="previewRecordPrompt" persistent max-width="80%">
      <student-scholarship-preview
        pageDescription="Student scholarship preview"
        :previewRecordPrompt="previewRecordPrompt"
        @hidePreviewRecordPrompt="hidePreviewRecordPrompt()"
        :recordData="selectedData"
        v-if="previewRecordPrompt"
      ></student-scholarship-preview>
    </v-dialog>
    <v-card>
      <v-card-title class="text-h5">
        <h2>{{ PageTitle }} - {{ YearName }}</h2>
        <v-spacer></v-spacer>
        <v-btn
          @click.prevent="pageData"
          color="#EDBE38"
          min-width="92"
          rounded
          mediums
          class="font-size-h6 px-3 py-3 mr-3 my-3 ml-3 white--text"
        >
          Refresh
        </v-btn>
      </v-card-title>

      <v-card-subtitle class="text-h5">
        <h4>
          {{ PageDescription }}
        </h4>
      </v-card-subtitle>

      <v-card-text>
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <v-container>
          <v-row wrap align="center">
            <!-- Year Selection -->
            <v-col cols="12" sm="6" md="3" lg="3">
              <label class="my-label">
                <h6><span class="text-danger">*</span> Year</h6>
              </label>
              <v-autocomplete
                :reduce="(option) => option.value"
                :items="JciYearCodeOptions"
                :rules="JciYearCodeRules"
                :loading="JciYearCodeOptionsLoading"
                v-model="JciYearCode"
                dense
                clearable
                required
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="3"
              class="d-flex align-center"
              v-if="rows.length > 0"
            >
              <json-excel
                v-if="DownloadFlag == 1"
                :data="rows"
                :fields="ExcelFields"
                worksheet="My Worksheet"
                :name="ExcelFileName"
              >
                <v-btn color="info">Download</v-btn>
              </json-excel>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" class="d-flex justify-end">
              <v-btn
                v-if="BulkUploadPermissionFlag"
                color="#006400"
                to="/student-scholarship/scholarship-issued/bulk-upload"
                class="font-size-h6 px-3 py-3 mr-3 my-3 white--text"
                rounded
                @click="bulkUpload"
              >
                Bulk Upload
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="py-0" v-if="rows.length > 0">
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search records here"
                single-line
                hide-details
              ></v-text-field>
              <br />
              <v-data-table
                class="elevation-1"
                v-model="selected"
                :headers="tableColumns1"
                :items="rows"
                :items-per-page="50"
                :search="search"
                item-key="MemberId"
                :single-select="false"
                :show-select="false"
                :footer-props="{
                  'items-per-page-options': [10, 20, 30, 40, 50],
                }"
              >
                <template v-slot:[`item.StudentApprovalStatusTxt`]="{ item }">
                  <v-chip
                    draggable
                    dark
                    :text-color="item.StudentApprovalStatusTxt"
                    :color="item.StudentApprovalStatusColor"
                    >{{ item.StudentApprovalStatusTxt }}</v-chip
                  >
                </template>
                <template v-slot:[`item.ScholarshipStatusTxt`]="{ item }">
                  <v-chip
                    draggable
                    dark
                    :text-color="item.ScholarshipStatusTxt"
                    :color="item.ScholarshipStatusColor"
                    >{{ item.ScholarshipStatusTxt }}</v-chip
                  >
                </template>
                <template v-slot:[`item.PhotoPath`]="{ item }">
                  <img width="100" height="100" :src="item.PhotoPath" />
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom v-if="item.PreviewFlag">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        icon
                        size="25px"
                        color="primary"
                        @click="previewData(item, e)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-file-search
                      </v-icon>
                    </template>
                    <span> Preview </span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.EditFlag">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        icon
                        size="25px"
                        color="warning"
                        @click="editData(item, e)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-file-document-edit
                      </v-icon>
                    </template>
                    <span> Edit Student </span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.DeleteFlag">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        icon
                        size="25px"
                        color="#e60b09"
                        @click="deleteConfirmAlert(item, e)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi mdi-delete
                      </v-icon>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
        <br /><br />
      </v-card-text>
    </v-card>
  </div>
</template>
  
    <script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import StudentScholarshipPreview from "@/view/pages/erp/student-scholarship/StudentScholarshipPreview.vue";
import Swal from "sweetalert2";

export default {
  components: { StudentScholarshipPreview },

  mixins: [common],
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SearchButtonFlag: false,
      SubmitFlag: false,
      SpeedDialFlag: false,
      rows: [],
      tableColumns1: [],
      tableOptions: [],
      selected: [],
      search: "",

      DownloadFlag: 0,
      ExcelFileName: "",
      ExcelFields: "",
      BulkUploadPermissionFlag: "",
      recordToEdit: "",
      record: {},
      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
      editPageDescription: "Assign LOM President for JCI India",

      LomDataPageTitle: "",
      LomDataPreviewFlag: false,
      LomDataParams: {},

      selectedData: {},
      tableData1: {},

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      zone: {},
      lom: {},

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  mounted() {
    /*
        this.$store.dispatch(SET_BREADCRUMB, [
          { title: "Vuetify", route: "alerts" },
          { title: "Form Inputs & Control", route: "autocompletes" },
          { title: "Fileinptus" },
        ]);
        */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
    JciYearCode: function () {
      console.log("watch JciYearCode");
      var JciYearCode = this.JciYearCode;
      console.log({ JciYearCode });
      if (JciYearCode > 0) {
        this.pageData();
      } else {
        this.rows = [];
      }
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "student_scholarship",
        Action: "list_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getJciYearCodeOptions();
      this.searchForm();
    },
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    deleteConfirmAlert(tr) {
      console.log("deleteConfirmAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        var htmlTxt = "";
        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: "Delete",
          confirmButtonColor: "#d33",
          cancelButtonText: "Cancel",
          cancelButtonColor: "#b2a496",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.deleteData(tr);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        if (n1 == 0) {
          message += "Kindly select one record to delete. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      this.searchForm();
    },
    getJciYearCodeOptions() {
      this.LoadingFlag = true;
      this.JciYearCodeOptionsLoading = true;
      console.log("getJciYearCodeOptions called");
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    searchForm() {
      console.log("searchForm is called");

      var YearCode = this.JciYearCode;
      console.log({ YearCode });

      if (YearCode > 0) {
        this.SearchFlag = true;
        this.rows = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/student/scholarship-issued/lists";
        var upload = {
          UserInterface: 1,
          Year: this.JciYearCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = [];
        var flag = 0;
        var table_data = {};
        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.TableContent;
            console.log({ records });

            thisIns.tableColumns1 = records.TableHeader;
            thisIns.tableOptions = records.TableOptions;
            thisIns.table_data = records.TableData;
            thisIns.BulkUploadPermissionFlag = records.BulkUploadPermissionFlag;
            console.log(
              "BulkUploadPermissionFlag:",
              thisIns.BulkUploadPermissionFlag
            );

            if (flag == 1) {
              thisIns.rows = records.TableData;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
    <style lang="scss">
/* This is for documentation purposes and will not be needed in your application */

#lom-list {
  .v-btn--floating {
    position: relative;
  }
  .v-speed-dial--bottom {
    bottom: 12%;
  }
  .v-speed-dial--right {
    right: 5%;
  }
  #card-text {
    text-align: center;
    color: white;
  }
  #card-text h5 {
    font-size: 34px;
  }
  #card-text h2 {
    font-size: 34px;
    font-weight: 900;
  }
  #card-text h1 {
    font-size: 44px;
    font-weight: 900;
  }
}
</style>